import constants from '../../common/constants/CommonConstants';
import {
  fetchLifecycleStages,
  reorderLifecycleStage,
  setDefaultLifecycleStage,
  addLifecycleStage,
  deleteLifecycleStage,
  renameLifecycleStage,
  fetchLifecycleStageSystemUsage,
} from '../routines';

const {
  ORGANIZATION_LEVEL,
  ACCOUNT_LEVEL,
  CONTACT_LEVEL,
  OPPORTUNITY_LEVEL,
  RISK_LEVEL,
} = constants;

const initialState = {
  isLoading: false,
  isOpInProgress: false,
  lifecycles: {
    [ORGANIZATION_LEVEL]: [],
    [ACCOUNT_LEVEL]: [],
    [CONTACT_LEVEL]: [],
    [OPPORTUNITY_LEVEL]: [],
    [RISK_LEVEL]: [],
  },
  usageData: {
    isLoading: false,
    isFailed: false,
    usage: undefined,
  },
};

export default function lifecyclesReducer(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case fetchLifecycleStageSystemUsage.TRIGGER: {
      const usageData = {
        ...state.usageData,
        isLoading: true,
        usage: undefined,
      };

      return { ...state, usageData };
    }
    case fetchLifecycleStageSystemUsage.SUCCESS: {
      const usageData = {
        ...state.usageData,
        isLoading: false,
        usage: action.payload.usage,
      };

      return { ...state, usageData };
    }
    case fetchLifecycleStageSystemUsage.FAILURE: {
      const usageData = {
        ...initialState.usageData,
        isFailed: true,
      };

      return { ...state, usageData };
    }
    case fetchLifecycleStages.TRIGGER:
      return { ...state, isLoading: true };
    case fetchLifecycleStages.SUCCESS: {
      const { response, entityLevel } = action.payload;
      const lifecycleStages = { ...state.lifecycles };

      lifecycleStages[entityLevel] = response.data;

      return {
        ...state,
        lifecycles: lifecycleStages,
        isLoading: false,
      };
    }
    case fetchLifecycleStages.FAILURE:
      return { ...state, isLoading: false };
    case reorderLifecycleStage.TRIGGER:
    case setDefaultLifecycleStage.TRIGGER:
    case addLifecycleStage.TRIGGER:
    case deleteLifecycleStage.TRIGGER:
    case renameLifecycleStage.TRIGGER:
      return { ...state, isOpInProgress: true };
    case reorderLifecycleStage.SUCCESS:
    case setDefaultLifecycleStage.SUCCESS:
    case addLifecycleStage.SUCCESS:
    case deleteLifecycleStage.SUCCESS:
    case renameLifecycleStage.SUCCESS:
    case reorderLifecycleStage.FAILURE:
    case setDefaultLifecycleStage.FAILURE:
    case addLifecycleStage.FAILURE:
    case deleteLifecycleStage.FAILURE:
    case renameLifecycleStage.FAILURE:
      return { ...state, isOpInProgress: false };
    default:
      return state;
  }
}
